import React, { Component } from 'react'
import './style.css'
import Banner from '../../assets/image/banner-homepage-3.jpg'
import Banner2 from '../../assets/image/banner-homepage2.jpg'
import {Button} from '@material-ui/core'
// import Slider from 'infinite-react-carousel';
import Carousel from 'react-responsive-carousel'
import {
    ButtonBack, ButtonFirst, ButtonLast, ButtonNext,
    CarouselProvider, DotGroup, ImageWithZoom, Slide, Slider,
  } from 'pure-react-carousel'
  import 'pure-react-carousel/dist/react-carousel.es.css';
import Chevron from '../../assets/image/chevron-right.svg'
import Breadcrum from '../breadcrum'
export default class tribe_banner2 extends Component {
    render() {
        const {image,bread_crum}=this.props
        let data=[
            {title:'aaaa'}, 
            {title:'bbbb'}, 
        ]
        console.log('image', image)
        return (
            <div>
                <section className='landing-tribe hide-mobile'>
                    {/* <div className='breadcrum'>
                        <p>{this.props.title}</p>
                        &nbsp;
                        <img src={Chevron} style={{width:6}}/>
                    </div> */}
                   
                    <div className='banner-tribe2'>
                    <Breadcrum data={bread_crum}/>
                        <br/>
                        <h1>{this.props.title}</h1>
                        <br/>
                        <p>{this.props.subtitle}</p>
                        <br/>
                        <Button variant="contained" style={{textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button>
                    </div>
                    <div className='banner-img' style={{textAlign:'center'}}>
                    <div className="dot"></div>
                    {/* {image!==undefined?
                        image.map
                    :} */}
                    {/* <Carousel showArrows={false} autoPlay infiniteLoop={true} showIndicators={false} showThumbs={false} showStatus={false} > */}
                   
                        {/* <div>
                        <div className="image">
                            <img src={Banner} className='banner-slider'/>
                        </div>
                        <div className='sadow'></div>
                        </div> */}
                    {/* </Carousel> */}
                    <CarouselProvider
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        totalSlides={image.length}
                        
                    >

                        <Slider>
                            {image.map((data,i)=>(
                                <Slide index={i} key={i}>
                                    <div className="image-slider"  style={{cursor:'pointer'}} onClick={()=>data.link!==null&&window.location.assign(data.link)}>
                                        <img src={data.image} className='banner-slider'/>
                                    </div>
                                    <div className='sadow'></div>
                                    <DotGroup className='dot-slider'/>
    
                                </Slide>
                            ))}
                            {/* <Slide index={0}>
                            <div>
                            <div className="image">
                                <img src={image!==undefined?image:Banner} className='banner-slider'/>
                            </div>
                            <div className='sadow'></div>
                            <DotGroup className='dot-slider'/>

                            </div>
                            </Slide>
                            <Slide index={1}>
                            <div className="image">
                                <img src={Banner2} className='banner-slider'/>
                            </div>
                            <div className='sadow'></div>
                            <DotGroup className='dot-slider'/>

                            </Slide> */}
                        
                        

                        </Slider>
                    </CarouselProvider>
                    </div>
                </section>
                <div className='tribe-banner2 show-mobile'>
                    {image.length>1?
                    <CarouselProvider
                        naturalSlideWidth={2}
                        naturalSlideHeight={2}
                        totalSlides={image.length}
                        isPlaying={true}
                        interval={5000}
                        playDirection='forward'
                    >
                        <Slider>
                        {image.map((data,i)=>(
                                <Slide index={i} key={i}>
                                    <div  className='image-banner2-mobile'  style={{cursor:'pointer'}} onClick={()=>data.link!==null&&window.location.assign(data.link)}>
                                        <img src={data.url} />
                                            <div className='dot-mobile'>
                                            <DotGroup className='dot-slider'/>
                                        </div>
                                    </div>
                                </Slide>
                            ))}
                            
                        </Slider>
                        
                    </CarouselProvider>
                    :
                    <div  className='image-banner2-mobile'>
                        <img src={image[0].image} />
                            <div className='dot-mobile'>
                        </div>
                    </div>
                    }
                    <div className='text-banner2'>
                        <h1>{this.props.title}</h1>
                        <br/>
                        <p>{this.props.subtitle}</p>
                        <br/>
                        <div style={{width:'100%',display:'flex',justifyContent:'center'}}>
                        <Button variant="contained" style={{textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}
